import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./logger";

ReactDOM.render(
  <App />,
 window.document.getElementById("root"),
);
